export type WebImageVariantKey =
  | 'thumb_320'
  | 'card_400'
  | 'hero_800'
  | 'hero_1000';

export type WebImageVariantUrls = Partial<Record<WebImageVariantKey, string>>;

export type MockupSideVariantUrls = WebImageVariantUrls &
  Partial<
    Record<'thumbnail' | 'small' | 'medium' | 'large' | 'original', string>
  >;

const WEB_VARIANT_TIER_RE =
  /\/(thumb_320|card_400|hero_800|hero_1000|thumbnail|small|medium)-\d+\.webp$/i;

export function isPreGeneratedWebVariantUrl(
  url: string | null | undefined,
): boolean {
  if (!url) return false;
  return WEB_VARIANT_TIER_RE.test(url);
}

export function pickShopCardWebVariantUrl(
  variants?: MockupSideVariantUrls | WebImageVariantUrls,
): string | undefined {
  if (!variants) return undefined;
  return (
    variants.card_400 ||
    variants.thumb_320 ||
    variants.thumbnail ||
    variants.hero_800 ||
    variants.small ||
    variants.medium ||
    variants.large ||
    variants.original
  );
}

export function pickPdpHeroWebVariantUrl(
  variants?: MockupSideVariantUrls | WebImageVariantUrls,
): string | undefined {
  if (!variants) return undefined;
  return (
    variants.hero_800 ||
    variants.hero_1000 ||
    variants.small ||
    variants.medium ||
    variants.card_400 ||
    variants.thumbnail ||
    variants.thumb_320 ||
    variants.large ||
    variants.original
  );
}

export function pickRailWebVariantUrl(
  variants?: MockupSideVariantUrls | WebImageVariantUrls,
): string | undefined {
  if (!variants) return undefined;
  return (
    variants.thumb_320 ||
    variants.card_400 ||
    variants.thumbnail ||
    variants.small ||
    variants.medium ||
    variants.large ||
    variants.original
  );
}

/** Confirmed API variant URLs only — never guessed CDN paths. */
export function sanitizeMockupSideVariants(
  variants?: MockupSideVariantUrls,
): MockupSideVariantUrls | undefined {
  if (!variants) return undefined;
  const out: MockupSideVariantUrls = {};
  const keys = [
    'thumb_320',
    'card_400',
    'hero_800',
    'hero_1000',
    'thumbnail',
    'small',
    'medium',
    'large',
    'original',
  ] as const;
  for (const key of keys) {
    const value = variants[key];
    if (typeof value === 'string' && value.trim()) {
      out[key] = value.trim();
    }
  }
  return Object.keys(out).length ? out : undefined;
}
